export const GTM_ID = 'GTM-5NZ5NSK'
export const GTM_QUERY_TAIL = ''
